<!-- Homepage Main Div -->
<div *ngIf="route.children.length === 0 && gridItems.length > 0">
    <div class="notification-help">
    </div>
    <div class="notification-home-main">
        <p class="select-info">Select the application </p>
        <div fxLayout="row wrap" fxLayoutGap="30px" class="notification-home-flex">
            <div *ngFor="let i of gridItems; let index = index">
                <div *ngIf="!i.hideApplication" class="card-container">
                <mat-card mat-stroked-button color="primary" appearance="outlined"
                    class="notification-home-card mat-elevation-z6" (click)="navigateToPreference(i)">
                    <img class="logo-styles" mat-card-image src="./../assets/allegion-card.svg" alt="">
                    <mat-card-content>
                        <p 
                        matTooltip="{{i.applicationName}}">
                        {{applicationNameDisplay( i.applicationName)}}
                        </p>
                    </mat-card-content>
                </mat-card>
            </div>
            </div>
        </div>
    </div>
</div>

<router-outlet></router-outlet>